import * as THREE from 'three';
import { labelPlane, roundedBox } from '../materials/MaterialFactory';
import { markInteractive } from './BaseComponent';

export class DIP14Chip extends THREE.Group {
  private topLabel: THREE.Mesh;

  constructor(model: string) {
    super();
    this.name = 'DIP-14 逻辑芯片';
    const body = new THREE.Mesh(
      roundedBox(5.2, 3.6, 0.8, 0.28),
      new THREE.MeshStandardMaterial({ color: 0x101419, roughness: 0.62, metalness: 0.12 })
    );
    body.rotation.x = -Math.PI / 2;
    body.position.y = 0.6;
    body.castShadow = true;
    this.add(body);

    const pinMaterial = new THREE.MeshStandardMaterial({ color: 0xbec7ce, metalness: 0.9, roughness: 0.25 });
    for (let side = 0; side < 2; side++) {
      for (let i = 0; i < 7; i++) {
        const pinNo = side === 0 ? i + 1 : 14 - i;
        const pin = new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.08, 0.85), pinMaterial);
        pin.position.set(-2.1 + i * 0.7, 0.38, side === 0 ? 2.15 : -2.15);
        pin.userData.pin = pinNo;
        pin.userData.label = pinNo === 1 ? '1A' : pinNo === 2 ? '1B' : pinNo === 3 ? '1Y' : pinNo === 7 ? 'GND' : pinNo === 14 ? 'VCC' : `未使用 ${pinNo}`;
        this.add(pin);
        const number = labelPlane([String(pinNo)], 0.38, 0.25, { background: '#101419', color: '#bfeeff', accent: '#101419' });
        number.rotation.x = -Math.PI / 2;
        number.position.set(pin.position.x, 1.05, side === 0 ? 1.44 : -1.44);
        if (side === 1) number.rotation.z = Math.PI;
        this.add(number);
      }
    }
    const notch = new THREE.Mesh(
      new THREE.TorusGeometry(0.34, 0.07, 8, 20, Math.PI),
      new THREE.MeshStandardMaterial({ color: 0x6f7982 })
    );
    notch.rotation.x = Math.PI / 2;
    notch.position.set(-2.5, 1.04, 0);
    this.add(notch);
    this.topLabel = this.createLabel(model);
    this.add(this.topLabel);
    markInteractive(this, {
      id: 'chip', name: '逻辑门芯片', english: 'Quad 2-input Logic IC', model,
      function: '内部包含四组两输入逻辑门；本实验只使用第一组。',
      connection: '1脚=1A，2脚=1B，3脚=1Y，7脚=GND，14脚=VCC。',
      mistake: 'VCC/GND 接反，或把未使用输入悬空。',
      tip: '顶部缺口用于识别引脚方向；逆时针编号。'
    });
  }

  setModel(model: string): void {
    this.remove(this.topLabel);
    const material = this.topLabel.material as THREE.MeshBasicMaterial;
    material.map?.dispose();
    material.dispose();
    this.topLabel.geometry.dispose();
    this.topLabel = this.createLabel(model);
    this.add(this.topLabel);
    this.userData.meta.model = model;
  }

  private createLabel(model: string): THREE.Mesh {
    const label = labelPlane([model, 'QUAD 2-INPUT · GATE 1 IN USE'], 3.8, 1.25, {
      background: '#101419', color: '#e0e6e8', accent: '#52616c'
    });
    label.rotation.x = -Math.PI / 2;
    label.position.y = 1.06;
    return label;
  }
}
